module.exports = __webpack_public_path__ + "static/media/sms-inbox.15bf9168.jpg";